import React, { useEffect, useState } from 'react';
import Bar from 'components/Bar';
import { ChatbotService, ConfigurationService } from 'services';
import { isMobile } from '@conversion-cloud-widget/UI';
import { Events, publish } from '@conversion-cloud-widget/pubsub';

const App = props => {
    /* App logic flow:
     * Load widget configuration
     * Load module specific data
     * Pass module data to a module bar to render module launcher(s)
     */
    const [chatBot, setChatBot] = useState(undefined);
    const [companyId, setCompanyId] = useState(undefined);
    const [backgroundColor, setBackgroundColor] = useState(undefined);
    const [xPosition, setXPosition] = useState(undefined);
    const [yPosition, setYPosition] = useState(undefined);
    const [mode, setMode] = useState(undefined);
    const [size, setSize] = useState(undefined);
    const [textColor, setTextColor] = useState(undefined);

    useEffect(() => {
        async function loadState() {
            const mobile = isMobile();
            const widgetConfiguration = await ConfigurationService.getWidgetConfiguration();
            const chatBotId = await ChatbotService.getChatBotId(widgetConfiguration);
            const chatBot = chatBotId
                ? await ChatbotService.getChatBot(chatBotId, widgetConfiguration.token)
                : undefined;

            if (!chatBot || typeof chatBot !== 'object') {
                return;
            }

            if (!chatBot.questions.questions || !chatBot.questions.questions.length) {
                return;
            }

            publish(Events.CHATBOT_LOADED, {
                chatbotId: chatBot.chatbot.id
            });

            const { widget_style: widgetMode } = widgetConfiguration;

            //Get the X and Y settings from the position
            const desktopPosition = widgetConfiguration.widget_position.split('-');
            const mobilePosition = widgetConfiguration.widget_position_mobile.split('-');

            //Defaults to use if there is no configuration for the widget
            const configuredSize = widgetConfiguration.widget_size || 'large';
            const configuredMode = widgetMode || 'dark';

            setXPosition(mobile ? mobilePosition[1] : desktopPosition[1]);
            setYPosition(mobile ? mobilePosition[0] : desktopPosition[0]);

            setBackgroundColor(props.backgroundColor);
            setTextColor(props.textColor);

            setCompanyId(widgetConfiguration.company_id);
            setMode(configuredMode);
            setSize(configuredSize);
            setChatBot(chatBot);
        }
        loadState();
    }, []);

    return chatBot ? (
        <Bar
            companyId={companyId}
            chatBot={chatBot}
            backgroundColor={backgroundColor}
            xPosition={xPosition}
            yPosition={yPosition}
            mode={mode}
            order={props.order}
            size={size}
            skin={props.skin || 'default'}
            textColor={textColor}
        />
    ) : (
        <></>
    );
};

export default App;
